const shortDates = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
export default shortDates;
